import Vue from 'vue'
import Vuex from 'vuex'
import {usersCollection, customAuth, mainAuth} from '@/FirebaseConfig' 
import {cleanObject, secondsToFullTimestamp} from '@/Helper' 
import router from '@/router'
Vue.use(Vuex)
export default {
    namespaced:true,
    state:{
        data:{
            name:'',
            role:'',
            address:'',
            document:'',
            phone:'',
            email:'',
            createdAt:'',
        },
        password: '',
        email: '',
        signOutDialog: false,
        loading: false,
        dialog: false,
        selectedKey:'',
        record:{},
        rolesRecord:{},
        Role :{},
    },
    mutations:{
        getAllItems(state, item) {
            Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
  
        clean(state,key){
            Vue.delete(state.record,key)
        }
    },
    actions:{
        getAll:context=>{
            context.state.record = {}
            usersCollection.onSnapshot(data=>data.docs.map( item => {
                
                if( item.data().customer && item.data().customer.indexOf(context.rootState.Customers.data.slug) > -1){
                    context.commit( 'getAllItems', item )
                }
            }))
        },
        logIn: (context, customer) => {
            context.state.loading = true
            mainAuth.signInWithEmailAndPassword(context.state.email, context.state.password)
            .then(async user=>{
                let userData = await context.dispatch('getUserByEmail', context.state.email)
                if(userData.customer.indexOf(customer)>-1){
                    context.dispatch('Customers/setCustomer', '', { root: true })
                    context.dispatch('Customers/getAllDocuments', '', { root: true })
                    customAuth.signInWithEmailAndPassword(context.state.email, context.state.password).then(()=>{
                        context.dispatch('setDisplayName', userData.name)
                        router.push({name: 'stock', params: {customerName: router.history.current.params.customerName} })
                    }).catch(error=> {
                        if(error.code == 'auth/user-not-found'){
                            customAuth.createUserWithEmailAndPassword(context.state.email, context.state.password).then( ()=>{
                                context.dispatch('setDisplayName', userData.name)
                                router.push({name: 'stock', params: {customerName: router.history.current.params.customerName} })
                            })
                        } else {
                            context.commit('Helpers/launchSnackbar', error, { root: true })
                        }
                    })
                } else {
                    context.commit('Helpers/launchSnackbar', 'No tiene acceso a esta base de datos', { root: true })
                    context.dispatch('logOut')
                }
                context.state.loading = false
            }).catch(error=>context.commit('Helpers/launchSnackbar', error, { root: true }))
        },
        signUp: (context, userData) => {
            
            mainAuth.createUserWithEmailAndPassword(context.state.email, context.state.password)
            .then( () =>{
                context.dispatch('Customers/setCustomer', '', { root: true })
                context.dispatch('Customers/getAllDocuments', '', { root: true })
                customAuth.createUserWithEmailAndPassword(context.state.email, context.state.password).then( ()=>{
                    context.dispatch('setDisplayName', userData.name)
                    context.commit('Helpers/launchSnackbar', 'Se ha registrado correctamente el usuario', { root: true })
                    context.state.loading = false
                    context.dispatch('Customers/getAllDocuments', '', { root: true })
                    router.push({name: 'stock', params: {customerName: router.history.current.params.customerName} })
                })
            })
            .catch(error=>context.commit('Helpers/launchSnackbar', error, { root: true }))
            
        },
        
        logOut: context => mainAuth.signOut().then(()=>customAuth.signOut().then(()=>router.push({name: 'logIn', params: {customerName: router.history.current.params.customerName} }) ) ),
        
        getUserByEmail: async (context, email) => {
            let consult = await usersCollection.where('email','==', email).get()
            if (consult.empty) {
                context.commit('Helpers/launchSnackbar', 'El usuario no se encuentra en la base de datos', { root: true }) 
                return false
            } else {
                return consult.docs[0].data()
            }
            
        },
        setDisplayName: (context, name) => {
            customAuth.currentUser.updateProfile({
                displayName: name
            }).then(()=>context.commit('Helpers/launchSnackbar', `Bienvenido ${name}`, { root: true }) )
        },
        validate: async (context) => {
            context.state.loading = true
            let userData = await context.dispatch('getUserByEmail', context.state.email)
            if (!userData) return
            context.dispatch('signUp', userData) 
            
        },
        add:context=>{
            if(context.state.selectedKey==''){
              usersCollection.add({...context.state.data, createdAt:new Date}).then(()=>{
                context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo usuario correctamente', { root: true })
                cleanObject(context.state.data)
                context.state.dialog = false
                })
            }else{
              usersCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
                context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })                  
                cleanObject(context.state.data)
                context.state.dialog=false
                })
            }
        },
        clean:(context, key)=>{
            usersCollection.doc(key).delete().then(()=>{{
                context.commit('Helpers/launchSnackbar', 'Se ha eliminado con éxito', { root: true })                
                context.commit('clean',key)}})
        },
        get:(context, key)=>{
            usersCollection.doc(key).get().then(doc=>{
              context.state.data = doc.data()
              context.state.selectedKey = key
              context.state.dialog = true
            })
        },
        clearForm:(context)=>{
            context.state.dialog = false
            context.state.selectedKey = ''
            context.state.data = {
              name: '',
              createdAt: ''
            }
        },
        getAllPrivileges: async context => {
            let privilegesList = Object.keys(context.rootState.Privileges.allRecord).map(item => context.rootState.Privileges.allRecord[item].routerName)
            let userDoc = await usersCollection.where('email', '==', customAuth.currentUser.email).get()
            
            let userId = userDoc.docs.map(item => item.id)
            usersCollection.doc(userId[0]).update({privileges : privilegesList}).then(()=>context.commit('Helpers/launchSnackbar', 'Ya posee todos los privilegios', { root: true }) )
            
        }
    },
    getters: {
        record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ),
    },
}
